import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { SpecialtyService } from "../services/specialty.service";

@Injectable({
    providedIn: "root"
})
export class StartScreeningGuard implements CanActivate {
    constructor(private specialtyService: SpecialtyService) {}

    canActivate(
        route: ActivatedRouteSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (route.fragment === "start-screening" && !sessionStorage.getItem("hcpSpecialty")) {
            this.specialtyService.openHcpModal();
            return false;
        }
        return true;
    }
}
